import { Avatar, Cushion, FlexContainer, Grid, Typography } from '@pitchero/react-ui';
import PropTypes from 'prop-types';
import React from 'react';
import ClubLink from '../club-link';

const FormGuidePlayer = ({ player, teamId }) => {
  const { id: playerId, avatar, name, position, value } = player;
  const wrapWithLink = (output) => {
    if (!teamId) {
      return output;
    }

    return (
      <ClubLink
        route="team.squad.profile"
        params={{ teamId, profileType: 'player', profileId: playerId, _profile: 'test' }}
      >
        <a>{output}</a>
      </ClubLink>
    );
  };

  return wrapWithLink(
    <Cushion
      horizontal="medium"
      responsive={[{ maxWidth: 600, props: { horizontal: 'small' } }]}
      component="div"
    >
      <Grid
        columns="auto 1fr auto"
        alignItems="center"
        columnGap="10px"
        style={{ width: '100%', boxSizing: 'border-box' }}
      >
        <Avatar image={avatar} alt={name} size={72} radius={10} />
        <FlexContainer flexDirection="column" style={{ gap: '5px' }}>
          <Typography preset="description" size={16} weight="bold" align="left" color="black">
            {name}
          </Typography>
          {position && (
            <Typography preset="description" size={14} color="dustygray">
              {position}
            </Typography>
          )}
        </FlexContainer>
        <Typography preset="description" color="black" size={18} weight="bold">
          {value}
        </Typography>
      </Grid>
    </Cushion>,
  );
};

FormGuidePlayer.propTypes = {
  player: PropTypes.shape({
    avatar: PropTypes.string.isRequired,
    name: PropTypes.string.isRequired,
    value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
    position: PropTypes.string,
  }).isRequired,
};

export default FormGuidePlayer;
